export const FeatureFlagConst = {
  FF1182_CODIGO_LYRA_PESSOAS: '1182-codigo-lyra-pessoas',
  FF1183_CODIGO_LYRA_TERRITORIO: '1183-codigo-lyra-territorio',
  // GS-3925: seção "Capacidade Produtiva" (e a chamada de produtividade) do Diagnóstico Socioambiental v2
  GS3925_CAPACIDADE_PRODUTIVA: 'gs3925-capacidade-produtiva'
};
